<template>
  <v-content>
    <v-container>
      <v-layout 
        align-center 
        justify-center>
        <v-flex xs12
          sm4
          align-center >
          <img
            src="/img/logo-login.png"
            class="logo"
          />       
        </v-flex>
      </v-layout>
      <v-layout
        flex
        align-center
        justify-center
      >
        <v-flex
          xs12
          sm4
        >
          <v-card class="login-box">
            <v-card-text class="pt-4">
              <v-toolbar-title >
                <h1>Verification Code</h1>
              </v-toolbar-title>
              <div>
                <ValidationObserver ref="observerCode" tag="form" @submit.prevent="verifyCode">
                  <ValidationProvider rules="required|min:4|max:4" v-slot="{ errors, valid }" name='phone_code'>                    
                    <v-text-field
                    :label="message"
                    v-model="phone_code"
                    data-vv-name="phone_code"
                    data-vv-validate-on="none"
                    required
                    autocomplete="false"
                    class="input"
                    :success="valid"
                    :error-messages="errors"
                    />
                  </ValidationProvider>
                  <v-layout wrapper-button class="mt-2" >
                    <v-btn type="submit" outlined color="primary">
                      Verify
                    </v-btn>
                  </v-layout>
                  <v-layout wrapper-button class="mt-2">
                    <v-btn type="submit" text color="primary" :to="{name : 'login'}">
                      Back to Log in
                    </v-btn>
                  </v-layout>
                </ValidationObserver>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      v-model="showResult"
      :timeout="2000"
      top
    >{{ result }}</v-snackbar>
  </v-content>
</template>

<script>
import AppConfig from '@/config/appConfig'
import AuthApi from '@/api/auth'
import decode from 'jwt-decode'
import storageUtil from '@/helpers/storage'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import validations from '@/modules/validations'
import Vue from 'vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      phone_code: null,
      verification_code:null,
      user:null,
      temp_token:null,
      showResult: false,
      result: null,
      authenticationType: this.$route.params.authentication_type,
      appLogo: AppConfig.appLogo2
    }
  },
  computed: {
    message () {
      return this.authenticationType == 'phone' ? 'Enter the code texted to your phone' : 'Enter the code sent by email (check the spam)'
    },
  },
  created () {
    this.generateCode()
  },
  methods: {
    generateCode(){
      const vm = this 
      storageUtil.setKey('auth_token', vm.$route.params.temp_token)
      var generateCodeModel = {
        email:vm.$route.params.email,
        authenticationType :this.authenticationType,
        appName:AppConfig.appName
      }
      return new Promise((resolve, reject) => {
        AuthApi.generateCode(generateCodeModel).then(
          data => {
            vm.temp_token = data.temp_token
            vm.user=data.user
          console.log('phone_code');
            vm.verification_code = decode(vm.temp_token).verification_code
            
          console.log(vm.verification_code);
            storageUtil.removeKey('auth_token')
          },
          error => {
            storageUtil.removeKey('auth_token')
            Vue.notify({
              group: 'general',
              type: 'error',
              text: error.message
            })
          }
        )
      })
    },
    verifyCode () {      
      const vm = this 
      vm.$refs.observerCode.validate().then(valid => {
        if (valid) {
          if(vm.verification_code==vm.phone_code){
            storageUtil.setKey('auth_token', vm.temp_token)
            vm.$store.dispatch('setUser', {            
                user: vm.user,
                token: vm.temp_token
              })
              vm.$router.push({ name: 'dashboard' })
          }
          else
          Vue.notify({
              group: 'general',
              type: 'error',
              text: "The code is not valid, try again or back to login."
            })
        }
      })
    }
  }
}
</script>
<style scoped>
.v-toolbar__title {
  width: 100%;
}
h1 {
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  text-align: left;
  color: black;
}
.login-box {
  border: 2px solid #244AB3;
  border-radius: 10% !important;
  min-height: 350px;
  min-width: 450px;
}
.logo {
       
  left: 40px;
}
.btn-login {
  background-color: #244AB3 !important;
  border-color: #244AB3 !important;
  border-radius: 45px;
  min-height: 48px;
  color: #244AB3;
}
.v-btn{
  text-transform: none !important;
}
.pt-4 {
  padding-top: 40px !important;
}
.wrapper-button {
  display: -webkit-box;
}
.v-btn {
  margin: 0 auto;
  display: flex;
}
</style>
